import React from 'react';
import './NewsDate.scss';

const NewsDate: React.FC = props => {
  return <div className="NewsDate">{props.children}</div>;
};

export default NewsDate;
